// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

'use strict';

import type { QueryType, SimpleFilter } from '@comped/alchemy2-shared';
import $ from 'jquery';

import { useValidator } from '../../src.ts/composables/validator';
import { _commons } from './common';
import { toComplexFilterJson } from './simpleFilter';

export function CommonValidator(obj) {
    Object.assign(this, useValidator(obj));
}
CommonValidator.prototype = {
};


export const Dialogs = {
    prefixObject(obj, prefix, add) {
        const result = {};
        for(const [key, value] of Object.entries(obj)) {
            if(!add && (key.startsWith(prefix))) {
                result[key.substring(prefix.length)] = value;
            } else if(add) {
                result[prefix + key] = value;
            } else {
                result[key] = value;
            }
        }
        return result;
    },
    loadDialog(dlg, obj, { optional, prefix, nameAttr }: { optional?: boolean; prefix?: string; nameAttr?: string } = {}) {
        if(prefix) obj = Dialogs.prefixObject(obj, prefix, true);
        if(!nameAttr) nameAttr = 'name';
        dlg = $(dlg);
        const elements = dlg.find(`[${nameAttr}]`).not('.no-form-serialize');
        elements.each(function() {
            const $this = $(this);
            const name = $this.attr(nameAttr);
            if(!name) {
                //name attribute may be empty
                return;
            }
            if(optional && !(name in obj)) {
                return;
            }
            const val = obj[name];
            _commons.tabledata.setControlValue($this, val);
        });
        elements.each(function() {
            const $this = $(this);
            $this.triggerHandler('auto-changed');
        });
        // ones, that should parse data based on other controls (AliquotaIVAExtended)
        elements.each(function() {
            const $this = $(this);
            $this.triggerHandler('parse-data');
        });
    },
    saveDialog(dlg, obj = undefined, { prefix, nameAttr }: { prefix?: string; nameAttr?: string } = {}) {
        if(!nameAttr) nameAttr = 'name';
        if(!obj) obj = {};
        dlg = $(dlg);
        dlg.find(`[${nameAttr}]`).not('.no-form-serialize').not(':disabled').each(function() {
            const $this = $(this);
            const name = $this.attr(nameAttr);
            if(!name) {
                //name attribute may be empty
                return;
            }
            obj[name] = _commons.tabledata.getControlValue($this);
        });
        if(prefix) obj = Dialogs.prefixObject(obj, prefix, false);
        return obj as Record<string, unknown>;
    },
    prepareSendFormData(dlg, params) {
        dlg = $(dlg);
        dlg.find('[name]').not(':disabled').not('[type="file"]').prop('disabled', true)
            .addClass('no-validate-disable');
        dlg.find('[name="params"]').prop('disabled', false).val(JSON.stringify(params));
        return new FormData(dlg.find('form')[0]);
    },
    afterSendFormData(dlg) {
        dlg.find('.no-validate-disable').prop('disabled', false).removeClass('no-validate-disable');
        dlg.find('[name="params"]').prop('disabled', true).val('');
    },
};

export const Tables = {
    addRestrictionFilter<T, K>(query: QueryType<T, K>, filter: SimpleFilter<K>) {
        const filter0 = query.table.filter;
        filter = toComplexFilterJson(filter);
        if(filter0) {
            filter = [{
                bool: 'and',
                filter: [...filter, ...filter0],
            }];
        }
        query.table.filter = filter;
    },
    useMappedRenderer(mapping: Record<string, string>) {
        return function(data: string | number | null | undefined) {
            if((data === null) || (data === undefined)) return '';
            const _data = String(data);
            const value = mapping[_data];
            return value ?? _data;
        };
    },
};

let DATA_TABLES_LANG;
try {
    DATA_TABLES_LANG = window.__DATA_TABLES_LANG__;
} catch(err) { /**/ }
try {
    if(!DATA_TABLES_LANG && window.__ROOT__) {
        DATA_TABLES_LANG = `${window.__ROOT__}local/lib/Italian.json`;
    }
} catch(err) { /**/ }

export const CommonTable = {
    processing: true,
    serverSide: true,
    ordering: true,
    searching: true,
    searchDelay: 1500,
    deferLoading: true,
    order: [[0, 'asc']],
    language: { url: DATA_TABLES_LANG },
    initComplete(settings) {
        _commons.tabledata.bindDatatableSearchWithDelay($(settings.nTable));
    },
};
